import React from "react";
import Grid from "../Grid";
import Card from "../Card";
import { AlarmClock, CircleHelp, Clock, CreditCard, FileCheck2, FileClock, History, TriangleAlert } from "lucide-react";
import Spacing from "../Spacing";
import { numberWithCommas } from "../../helpers";
import Skeleton from "react-loading-skeleton";

export default function RejectionOverViewSection({ rejectionOverviewDataCounts, rejectionOverviewLoader }) {

  return (
    <div className="docpro_table_responsive dashboard">
      <Grid variant="docpro_grid docpro_grid_gap_10 docpro_grid_col_4 docpro_main_cards">
        <span className="docpro_card_1_link pointer">
          <Card variant="docpro_card_md docpro_card_1">
            <h3 className="docpro_fs_14 docpro_mb_0 docpro_ternary_color">
              <FileClock width={20} height={20} /> Total Pending
            </h3>
            <Spacing lg="4" sm="4" />
            <div>
              {!rejectionOverviewLoader ?
                <p className="docpro_fw_500 docpro_fs_24 docpro_primary_color docpro_mb_0">
                  {numberWithCommas(rejectionOverviewDataCounts?.total_pending_count || 0)}
                </p>
              :
                <Skeleton width="5rem" height="1.86rem" borderRadius="8px"></Skeleton>
              }
            </div>
          </Card>
        </span>
        <span className="docpro_card_1_link pointer">
          <Card variant="docpro_card_md docpro_card_1">
            <h3 className="docpro_fs_14 docpro_mb_0 docpro_ternary_color">
              <FileCheck2 width={20} height={20} /> Total Paid
            </h3>
            <Spacing lg="4" sm="4" />
            <div>
              {!rejectionOverviewLoader ?
                <p className="docpro_fw_500 docpro_fs_24 docpro_primary_color docpro_mb_0">
                  {numberWithCommas(rejectionOverviewDataCounts?.total_paid_count || 0)}
                </p>
              :
                <Skeleton width="5.5rem" height="1.86rem" borderRadius="8px"></Skeleton>
              }
            </div>
          </Card>
        </span>
        <span className="docpro_card_1_link pointer">
          <Card variant="docpro_card_md docpro_card_1">
            <h3 className="docpro_fs_14 docpro_mb_0 docpro_ternary_color">
              <History width={20} height={20} /> Before Resubmit
            </h3>
            <Spacing lg="4" sm="4" />
            <div>
              {!rejectionOverviewLoader ?
                <p className="docpro_fw_500 docpro_fs_24 docpro_primary_color docpro_mb_0">
                  {`$${numberWithCommas(
                    rejectionOverviewDataCounts?.total_before_resubmit_count
                      ? rejectionOverviewDataCounts?.total_before_resubmit_count
                      : 0
                    )}`
                  }
                </p>
              :
                <Skeleton width="7rem" height="1.86rem" borderRadius="8px"></Skeleton>
              }
            </div>
          </Card>
        </span>
        <span className="docpro_card_1_link pointer">
          <Card variant="docpro_card_md docpro_card_1">
            <h3 className="docpro_fs_14 docpro_mb_0 docpro_ternary_color">
              <Clock width={20} height={20} /> After Resubmit
            </h3>
            <Spacing lg="4" sm="4" />
            <div>
              {!rejectionOverviewLoader ?
                <p className="docpro_fw_500 docpro_fs_24 docpro_primary_color docpro_mb_0">
                  {`$${numberWithCommas(
                    rejectionOverviewDataCounts?.total_after_resubmit_count
                      ? rejectionOverviewDataCounts?.total_after_resubmit_count
                      : 0
                    )}`
                  }
                </p>
              :
                <Skeleton width="7.5rem" height="1.86rem" borderRadius="8px"></Skeleton>
              }
            </div>
          </Card>
        </span>
        <span className="docpro_card_1_link pointer">
          <Card variant="docpro_card_md docpro_card_1">
            <h3 className="docpro_fs_14 docpro_mb_0 docpro_ternary_color">
              <AlarmClock width={20} height={20} /> Total Resubmitted
            </h3>
            <Spacing lg="4" sm="4" />
            <div>
              {!rejectionOverviewLoader ?
                <p className="docpro_fw_500 docpro_fs_24 docpro_primary_color docpro_mb_0">
                  {numberWithCommas(rejectionOverviewDataCounts?.total_resubmitted_count || 0)}
                </p>
              :
                <Skeleton width="4rem" height="1.86rem" borderRadius="8px"></Skeleton>
              }
            </div>
          </Card>
        </span>
        <span className="docpro_card_1_link pointer">
          <Card variant="docpro_card_md docpro_card_1">
            <h3 className="docpro_fs_14 docpro_mb_0 docpro_ternary_color">
              <TriangleAlert width={20} height={20} /> Again Denied
            </h3>
            <Spacing lg="4" sm="4" />
            <div>
              {!rejectionOverviewLoader ?
                <p className="docpro_fw_500 docpro_fs_24 docpro_primary_color docpro_mb_0">
                  {numberWithCommas(rejectionOverviewDataCounts?.total_again_denied_count || 0)}
                </p>
              :
                <Skeleton width="4rem" height="1.86rem" borderRadius="8px"></Skeleton>
              }
            </div>
          </Card>
        </span>
        <span className="docpro_card_1_link pointer">
          <Card variant="docpro_card_md docpro_card_1">
            <h3 className="docpro_fs_14 docpro_mb_0 docpro_ternary_color">
              <CircleHelp width={20} height={20} /> Need Clinic's Help
            </h3>
            <Spacing lg="4" sm="4" />
            <div>
              {!rejectionOverviewLoader ?
                <p className="docpro_fw_500 docpro_fs_24 docpro_primary_color docpro_mb_0">
                  {numberWithCommas(rejectionOverviewDataCounts?.total_need_clinics_help || 0)}
                </p>
              :
                <Skeleton width="4.5rem" height="1.86rem" borderRadius="8px"></Skeleton>
              }
            </div>
          </Card>
        </span>
        <span className="docpro_card_1_link pointer">
          <Card variant="docpro_card_md docpro_card_1">
            <h3 className="docpro_fs_14 docpro_mb_0 docpro_ternary_color">
              <CreditCard width={20} height={20} /> Write Off
            </h3>
            <Spacing lg="4" sm="4" />
            <div>
              {!rejectionOverviewLoader ?
                <p className="docpro_fw_500 docpro_fs_24 docpro_primary_color docpro_mb_0">
                  {numberWithCommas(rejectionOverviewDataCounts?.total_write_off_count || 0)}
                </p>
              :
                <Skeleton width="4.5rem" height="1.86rem" borderRadius="8px"></Skeleton>
              }
            </div>
          </Card>
        </span>
      </Grid>
    </div>
  );
}
